import {
  ShieldLockFill,
  DatabaseFill,
  GearFill,
  HddFill,
  EnvelopeFill,
} from 'react-bootstrap-icons';

const SECTIONS = [
  {
    icon: <DatabaseFill />,
    title: 'Information We Collect',
    body: (
      <>
        <p>Paragon Conquer collects information that you provide directly to us, including:</p>
        <ul>
          <li>Account credentials (username, password hash) provided when registering.</li>
          <li>Contact information such as your email address.</li>
          <li>Any information you submit through support tickets or other forms on the website.</li>
        </ul>
      </>
    ),
  },
  {
    icon: <GearFill />,
    title: 'How We Use Your Data',
    body: (
      <>
        <p>We process your information when necessary to provide you with the services included when playing the server.</p>
        <ul>
          <li>Account and identifiable information is kept strictly confidential.</li>
          <li>Personal information is only used to verify identity, assist with identification, and determine appropriate services.</li>
          <li>For example, we may use your email to assist you in recovering your account if access has been lost.</li>
        </ul>
      </>
    ),
  },
  {
    icon: <HddFill />,
    title: 'Cookies & Local Storage',
    body: (
      <p>Our website may utilise cookies or similar browser features to save your information for faster login and an improved experience. You may clear these at any time through your browser settings.</p>
    ),
  },
  {
    icon: <EnvelopeFill />,
    title: 'Contact Us',
    body: (
      <p>If you have any enquiries regarding our privacy policy, please contact us through our website or our Discord server and we will respond promptly.</p>
    ),
  },
];

export function PrivacyPolicy() {
  return (
    <div className="policy-page">
      <div className="policy-hero">
        <div className="policy-hero-icon"><ShieldLockFill /></div>
        <h2>Privacy Policy</h2>
        <p>How Paragon Conquer collects and uses your information.</p>
      </div>

      {SECTIONS.map((s, i) => (
        <div key={i} className="policy-section">
          <div className="policy-section-header">
            <span className="policy-section-icon">{s.icon}</span>
            <h5>{s.title}</h5>
          </div>
          <div className="policy-section-body">{s.body}</div>
        </div>
      ))}

      <div className="policy-note">
        <p>We are committed to protecting your privacy. Your data will never be sold or shared with third parties outside of what is required to operate the server.</p>
      </div>
    </div>
  );
}
